import React from 'react'
import './comingSoon.css'

export default function ComingSoon() {
    return (
        <div className='coming-soon'>
            <div className='coming-soon-text'>
                <h1>Coming Soon</h1>
                <p>Stay tuned for more updates!</p>
            </div>
            <form className='early-access-form' action='post' netlify>
                <input type='text' placeholder='Name' />
                <input type='text' placeholder='Email' />
                <button type='submit'>Get Early Access</button>
            </form>
        </div>
    )
}
